import styled from 'styled-components';
import { Typ80 } from 'dc/Typ';
import Load05 from 'dc/Load05';

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  min-height: 100vh;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Text = styled(Typ80)``;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(169.97deg, #007079 0%, #1db3d9 100%);
`;

export const Loader = styled(Load05)``;

export const Version = styled.p`
  width: 100%;
  color: #6c6c6c;
  padding: 16px;
  margin: 0;
  font-size: 10px;
`;
